import { buildApiEnvironment } from './build-api-environment';

const BASE_URL = 'https://nilo-dev.prosegur.dev';

export const environment = {
  production: true,
  releaseStage: 'dev',
  bugsnag: {
    key: '3ec8fab0a9c116e77d6e6ed513dcb6eb'
  },

  api: buildApiEnvironment(BASE_URL),

  auth: {
    clientId: '38122071-75dc-4eb8-82c0-ddc9315f0899',
    loginUrl:
      'https://login.microsoftonline.com/68485601-fbbc-47c6-b156-3e1a7e0a4434/oauth2/v2.0/authorize',
    issuer: 'https://login.microsoftonline.com/68485601-fbbc-47c6-b156-3e1a7e0a4434/v2.0',
    redirectUri: `${BASE_URL}/nilo-ui/oauth-callback`,
    tokenEndpoint: `${BASE_URL}/nilo-user/users/actions/login`
  }
};
